import axios from 'axios';
/**
 * Set local instance of axios to use csurf, so we can secure our POST requests.
 * Later when we use axios we need to require this local instance
 * of axios instead the original one.
 */

const instance = axios.create({
	xsrfCookieName: 'react-session',
	xsrfHeaderName: 'csrf-token',
});

instance.CancelToken = axios.CancelToken;
instance.isCancel = axios.isCancel;

// Export default local instance of axios.
export default instance;
